<template>
	<v-list-item :id="'alert' + data.id" two-line @click="openUrl()"> <!--:href="data.url ? data.url : ''" target="_blank">-->
		<v-list-item-avatar size="40" tile style="margin: 0 12px 0 0;">
			<v-img :src="require(data.link.endsWith('.pdf') ? 
				'../../assets/icolis_pdf_big_circle.png' : '../../assets/icolis_web_big_circle.png')" width="50"/>
		</v-list-item-avatar>
		<v-list-item-content>
			<v-list-item-subtitle class="icoev-date-text" style="margin: 0 0 10px 0;">{{ data.fecha }}</v-list-item-subtitle>
			<v-list-item-title style="white-space: normal; font-size: 14px;">{{ data.titulo }}</v-list-item-title>
		</v-list-item-content>
	</v-list-item>
</template>

<script>
import BaseModule from "./BaseModule";
import cordova from "../../api/cordova";

export default {
	name: 'AlertItem',
	mixins: [ BaseModule ],
	props: [ 'data' ],
	data() {
		return {
			openUrl() {
				if (this.$store.state.icoev.device.platform == 'browser') {
					window.open(this.data.link);
					return;
				}

				/*if (this.data.link.endsWith('.pdf') && this.$store.state.icoev.device.platform == 'android') {
					cordova.downloadUrl('document_' + new Date().getTime(), encodeURI(this.data.link));
				} else {*/
					cordova.openUrl(encodeURI(this.data.link));
				//}

				//this.$emit('open-external-content', 'Detalle alerta', this.data.link);
			}
		}
	},
}
</script>